(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[56],{

/***/ 29973:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
}), 'ArrowForward');

exports.Z = _default;

/***/ }),

/***/ 38628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ CMSChildrenContainer; },
  "Z": function() { return /* binding */ ChildrenContainer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./utils/stylesHelper.ts
// Future improvement could be to add baseClasses as a potential array - either array or string
// if (Array.isArray(baseClass)) { return [...baseClass, className].join(" ")
function combineClasses(baseClass, className) {
    return className ? "".concat(baseClass, " ").concat(className) : baseClass;
}

// EXTERNAL MODULE: ./components/CMS/ChildrenContainer/style.module.scss
var style_module = __webpack_require__(88460);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./components/CMS/ChildrenContainer/index.tsx




var CMSChildrenContainer = function(param) {
    var children = param.children, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: combineClasses((style_module_default()).childrenContainer, className),
        children: children
    });
};
/* harmony default export */ var ChildrenContainer = (CMSChildrenContainer);


/***/ }),

/***/ 78868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ CmsImage_CmsImage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(29260);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/CMS/CmsImage/getImageUrl.ts
var getImageUrl = function(imageFormats, smallestImageFormat, fallbackImageUrl) {
    if (!imageFormats) {
        return fallbackImageUrl;
    }
    if (imageFormats[smallestImageFormat]) {
        return imageFormats[smallestImageFormat].url;
    }
    var currentSmallestImageFormat = smallestImageFormat;
    var availableimageFormats = [
        "thumbnail",
        "small",
        "medium",
        "large"
    ];
    while(!imageFormats[currentSmallestImageFormat]){
        if (currentSmallestImageFormat === "large") {
            return fallbackImageUrl;
        }
        currentSmallestImageFormat = availableimageFormats[availableimageFormats.indexOf(currentSmallestImageFormat) + 1];
        if (imageFormats[currentSmallestImageFormat]) {
            return imageFormats[currentSmallestImageFormat].url;
        }
    }
};

;// CONCATENATED MODULE: ./components/CMS/CmsImage/CmsImage.tsx




var CmsImage = function(param) {
    var imageProps = param.imageProps, altText = param.altText, format = param.format, quality = param.quality, layout = param.layout, height = param.height, width = param.width, objectFit = param.objectFit, priority = param.priority, className = param.className, sizes = param.sizes;
    var imageUrl = getImageUrl(imageProps.formats, format, imageProps.url);
    return imageUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
        className: className,
        alt: altText,
        src: imageUrl,
        priority: priority,
        layout: layout,
        objectFit: objectFit,
        quality: quality,
        height: height,
        width: width,
        sizes: sizes
    }) : null;
};
/* harmony default export */ var CmsImage_CmsImage = (CmsImage);

;// CONCATENATED MODULE: ./components/CMS/CmsImage/index.ts



/***/ }),

/***/ 80056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CMSImageText": function() { return /* binding */ CMSImageText; },
  "ImageTextStyle": function() { return /* binding */ ImageTextStyle; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/CMS/ChildrenContainer/index.tsx + 1 modules
var ChildrenContainer = __webpack_require__(38628);
// EXTERNAL MODULE: ./components/CMS/constants.ts
var constants = __webpack_require__(3379);
// EXTERNAL MODULE: ./components/CMS/style.module.scss
var style_module = __webpack_require__(88415);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./components/CMS/CmsImage/index.ts + 2 modules
var CmsImage = __webpack_require__(78868);
// EXTERNAL MODULE: ./components/CMS/LinkElement/index.tsx
var LinkElement = __webpack_require__(7098);
// EXTERNAL MODULE: ./components/CMS/MarkdownCMSModule/index.tsx
var MarkdownCMSModule = __webpack_require__(8037);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/Image/index.tsx + 2 modules
var Image = __webpack_require__(87113);
// EXTERNAL MODULE: ./components/CMS/ImageTextCover/ImageTextCover.module.scss
var ImageTextCover_module = __webpack_require__(14801);
var ImageTextCover_module_default = /*#__PURE__*/__webpack_require__.n(ImageTextCover_module);
;// CONCATENATED MODULE: ./components/CMS/ImageTextCover/ImageTextCover.tsx












var ImageTextCover = function(param) {
    var imageText = param.imageText, layoutBackground = param.layoutBackground, coverImageAlignment = param.coverImageAlignment;
    var title = imageText.title, blurb = imageText.blurb, images = imageText.images, button_text = imageText.button_text, button_style = imageText.button_style, button_URL = imageText.button_URL;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (style_module_default()).containerMarginS,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
            container: true,
            className: coverImageAlignment === "Left" ? (ImageTextCover_module_default()).leftImage : "",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    xs: 12,
                    md: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((ImageTextCover_module_default()).content, layoutBackground === "Light" ? (ImageTextCover_module_default()).lightBackground : ""),
                        children: [
                            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h5",
                                className: (ImageTextCover_module_default()).title,
                                children: title
                            }),
                            blurb && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ImageTextCover_module_default()).blurb,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkdownCMSModule/* MarkdownCMSModule */.R, {
                                    source: blurb
                                })
                            }),
                            button_URL && /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkElement/* LinkElement */.E, {
                                linkText: button_text,
                                link: button_URL,
                                linkStyle: button_style
                            })
                        ]
                    })
                }),
                (images === null || images === void 0 ? void 0 : images.length) > 0 && images[0].url && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    xs: 12,
                    md: true,
                    className: (ImageTextCover_module_default()).imageContainer,
                    children: button_URL ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        prefetch: false,
                        href: button_URL,
                        as: button_URL,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: button_URL,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ImageTextCover_module_default()).imageWrapper,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CmsImage/* default */.Z, {
                                    layout: "fill",
                                    objectFit: "cover",
                                    imageProps: images[0],
                                    altText: images[0].alternativeText || Image/* defaultAlt */.Zp,
                                    format: "medium",
                                    className: (ImageTextCover_module_default()).img,
                                    sizes: "(max-width: 1200px) 50vw, 100vw"
                                })
                            })
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ImageTextCover_module_default()).imageWrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CmsImage/* default */.Z, {
                            className: (ImageTextCover_module_default()).img,
                            layout: "fill",
                            objectFit: "cover",
                            imageProps: images[0],
                            altText: images[0].alternativeText || Image/* defaultAlt */.Zp,
                            format: "medium",
                            sizes: "(max-width: 1200px) 50vw, 100vw"
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var ImageTextCover_ImageTextCover = (ImageTextCover);

;// CONCATENATED MODULE: ./components/CMS/ImageTextCover/index.ts


// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(29260);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/CMS/ImageText/style.module.scss
var ImageText_style_module = __webpack_require__(95815);
var ImageText_style_module_default = /*#__PURE__*/__webpack_require__.n(ImageText_style_module);
;// CONCATENATED MODULE: ./components/CMS/ImageText/item.tsx















var SimpleImageSlider = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3225).then(__webpack_require__.t.bind(__webpack_require__, 83225, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(83225)
            ];
        }
    },
    ssr: false
});
var imageSizeMap = function(style) {
    switch(style){
        case ImageTextStyle.OneColumn:
            return {
                height: 304,
                width: 766
            };
        case ImageTextStyle.ImageRight:
            return {
                height: 304,
                width: 450
            };
        case ImageTextStyle.ImageLeft:
            return {
                height: 304,
                width: 450
            };
        case ImageTextStyle.TwoColumn:
            return {
                height: 216,
                width: 450
            };
        case ImageTextStyle.ThreeColumn:
            return {
                height: 160,
                width: 292
            };
        default:
            return {
                height: 304,
                width: 924
            };
    }
};
var Item = function(param) {
    var data = param.data, gridDirection = param.gridDirection, style = param.style, alignment = param.alignment, layoutBackground = param.layoutBackground, coverImageAlignment = param.coverImageAlignment;
    var title = data.title, images = data.images, blurb = data.blurb, _button_style = data.button_style, button_style = _button_style === void 0 ? constants/* LinkStyle.Button */.uj.Button : _button_style, button_URL = data.button_URL, _button_text = data.button_text, button_text = _button_text === void 0 ? "" : _button_text;
    var imageSize = imageSizeMap(style);
    var sliderImages = images === null || images === void 0 ? void 0 : images.reduce(function(acc, curr) {
        if (curr.url) {
            acc.push({
                url: curr.url
            });
        }
        return acc;
    }, []);
    var isSlidesShow = (sliderImages === null || sliderImages === void 0 ? void 0 : sliderImages.length) > 1 && style !== ImageTextStyle.TwoColumn && style != ImageTextStyle.ThreeColumn;
    var isMultiItem = style === ImageTextStyle.ThreeColumn || style === ImageTextStyle.TwoColumn;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            style === ImageTextStyle.Cover && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageTextCover_ImageTextCover, {
                imageText: data,
                layoutBackground: layoutBackground,
                coverImageAlignment: coverImageAlignment
            }),
            style !== ImageTextStyle.Cover && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                        container: true,
                        direction: gridDirection !== null && gridDirection !== void 0 ? gridDirection : "column",
                        spacing: 3,
                        className: (ImageText_style_module_default()).itemContainer,
                        children: [
                            (images === null || images === void 0 ? void 0 : images.length) > 0 && images[0].url && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                item: true,
                                xs: 12,
                                md: true,
                                children: isSlidesShow ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()((ImageText_style_module_default()).img, (ImageText_style_module_default()).imageSlider),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleImageSlider, {
                                        showNavs: true,
                                        showBullets: true,
                                        width: imageSize.width,
                                        height: imageSize.height,
                                        images: sliderImages
                                    })
                                }) : button_URL ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    prefetch: false,
                                    href: button_URL,
                                    as: button_URL,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: button_URL,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: classnames_default()((ImageText_style_module_default()).imgWrapper, (ImageText_style_module_default()).notImageSlider),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                layout: "fill",
                                                className: (ImageText_style_module_default()).img,
                                                src: images[0].url,
                                                alt: images[0].alternativeText || Image/* defaultAlt */.Zp
                                            })
                                        })
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()((ImageText_style_module_default()).imgWrapper, (ImageText_style_module_default()).notImageSlider),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        layout: "fill",
                                        className: (ImageText_style_module_default()).img,
                                        src: images[0].url,
                                        alt: images[0].alternativeText || Image/* defaultAlt */.Zp
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                item: true,
                                xs: 12,
                                md: true,
                                children: [
                                    title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "h6",
                                        className: (ImageText_style_module_default()).title,
                                        children: title
                                    }),
                                    blurb && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (ImageText_style_module_default()).blurb,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkdownCMSModule/* MarkdownCMSModule */.R, {
                                            source: blurb
                                        })
                                    }),
                                    button_URL && !isMultiItem && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkElement/* LinkElement */.E, {
                                            link: button_URL,
                                            linkStyle: button_style,
                                            linkText: button_text,
                                            align: alignment
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    button_URL && isMultiItem && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkElement/* LinkElement */.E, {
                            link: button_URL,
                            linkStyle: button_style,
                            linkText: button_text,
                            align: alignment
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/CMS/ImageText/index.tsx









var ImageTextStyle;
(function(ImageTextStyle) {
    ImageTextStyle["FullWidth"] = "Full_Width";
    ImageTextStyle["ImageLeft"] = "Two_Column_Image_Left";
    ImageTextStyle["ImageRight"] = "Two_Column_Image_Right";
    ImageTextStyle["OneColumn"] = "One_Column";
    ImageTextStyle["TwoColumn"] = "Two_Column";
    ImageTextStyle["ThreeColumn"] = "Three_Column";
    ImageTextStyle["Cover"] = "Cover";
})(ImageTextStyle || (ImageTextStyle = {}));
var styleToGridColumn = function(style) {
    return style === ImageTextStyle.ThreeColumn ? 4 : 6;
};
var styleToGridDirection = function(style) {
    switch(style){
        case ImageTextStyle.ImageLeft:
            return constants/* GridDirection.Row */.mp.Row;
        case ImageTextStyle.ImageRight:
            return constants/* GridDirection.RowReverse */.mp.RowReverse;
    }
    return constants/* GridDirection.Column */.mp.Column;
};
var CMSImageText = function(param) {
    var image_collection = param.image_collection, image_collections = param.image_collections, layout = param.layout, layout_background = param.layout_background, cover_image_alignment = param.cover_image_alignment, heading = param.heading, alignment = param.alignment;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChildrenContainer/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (style_module_default()).containerMarginS,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ImageText_style_module_default()).heading,
                    children: heading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h4",
                        component: "h5",
                        children: heading
                    })
                }),
                image_collections && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ImageText_style_module_default())[layout],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        container: true,
                        spacing: 3,
                        children: image_collections.map(function(i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                item: true,
                                xs: 12,
                                md: styleToGridColumn(layout),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: layout === ImageTextStyle.ThreeColumn || layout === ImageTextStyle.TwoColumn ? (ImageText_style_module_default()).itemContent : "",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                                        data: i,
                                        style: layout,
                                        alignment: alignment
                                    })
                                })
                            }, i.id);
                        })
                    })
                }),
                image_collection && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ImageText_style_module_default())[layout],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                        data: image_collection,
                        gridDirection: styleToGridDirection(layout),
                        style: layout,
                        layoutBackground: layout_background,
                        coverImageAlignment: cover_image_alignment,
                        alignment: alignment
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 7098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ LinkElement; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _app_utils_useAnalytics__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9800);
/* harmony import */ var _cmsComponents_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3379);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(282);
/* harmony import */ var _material_ui_icons_ArrowForward__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(29973);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99263);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_5__);








var LinkElement = function(param) {
    var linkText = param.linkText, link = param.link, linkStyle = param.linkStyle, _align = param.align, align = _align === void 0 ? _cmsComponents_constants__WEBPACK_IMPORTED_MODULE_2__/* .Alignment.Center */ .v2.Center : _align, buttonClassName = param.buttonClassName, trackAction = param.trackAction;
    var track = (0,_app_utils_useAnalytics__WEBPACK_IMPORTED_MODULE_1__/* .useAnalytics */ .z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_5___default().container),
        children: linkStyle === _cmsComponents_constants__WEBPACK_IMPORTED_MODULE_2__/* .LinkStyle.HyperLink */ .uj.HyperLink ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_5___default())[align],
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                href: link,
                className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_5___default().hyperLink),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: linkText
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_ArrowForward__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
                ]
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_5___default())[align],
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                variant: "contained",
                color: "secondary",
                onClick: function() {
                    return track("Click", {
                        action: trackAction !== null && trackAction !== void 0 ? trackAction : "CMS Button Click",
                        "element text": linkText !== null && linkText !== void 0 ? linkText : "",
                        "element type": "button"
                    });
                },
                href: link,
                className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_style_module_scss__WEBPACK_IMPORTED_MODULE_5___default().button), (_style_module_scss__WEBPACK_IMPORTED_MODULE_5___default())[linkStyle || "Button"], buttonClassName),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_5___default().linkText),
                    children: linkText
                })
            })
        })
    });
};


/***/ }),

/***/ 8037:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ MarkdownCMSModule; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _cmsComponents_style_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88415);
/* harmony import */ var _cmsComponents_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_cmsComponents_style_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30724);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_markdown__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var components_CMS_MarkdownRenderer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70738);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57231);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_5__);







var MarkdownCMSModule = function(param) {
    var source = param.source, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_markdown__WEBPACK_IMPORTED_MODULE_3___default()), {
        renderers: components_CMS_MarkdownRenderer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
        className: className !== null && className !== void 0 ? className : classnames__WEBPACK_IMPORTED_MODULE_1___default()((_style_module_scss__WEBPACK_IMPORTED_MODULE_5___default().markdown), (_cmsComponents_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default().markdownContent)),
        escapeHtml: false,
        children: source
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MarkdownCMSModule);


/***/ }),

/***/ 70738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29260);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91066);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable react/display-name */ 



var MarkdownRenderer = {
    link: function(props) {
        var href = props.href, children = props.children;
        var shouldUseTargetSelf = /^(https?):\/\//.test(href) ?  true ? href.startsWith(window.location.origin) // In case someone pastes the full URL
         : 0 : /*
         * Anything else should use target="_self". Especially anything that starts with mailto, tel, or javascript
         */ true;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: href,
            target: shouldUseTargetSelf ? "_self" : "_blank",
            rel: "noreferrer noopener",
            children: children
        });
    },
    image: function(props) {
        var src = props.src, title = props.title;
        if (src.match(/\.(jpeg|jpg|gif|png)$/)) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                        src: src,
                        style: {
                            display: "block",
                            width: "80%",
                            height: "400px",
                            objectFit: "cover",
                            margin: "0 auto"
                        },
                        alt: "cover image"
                    }),
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().imageAndLinkTitle),
                        children: title
                    })
                ]
            });
        }
        if (src.match(/\.(mp4|ogg|webm)$/)) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                        controls: true,
                        className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().videoPlayer),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                            src: src
                        })
                    }),
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().imageAndLinkTitle),
                        children: title
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (MarkdownRenderer);


/***/ }),

/***/ 3379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mp": function() { return /* binding */ GridDirection; },
/* harmony export */   "uj": function() { return /* binding */ LinkStyle; },
/* harmony export */   "v2": function() { return /* binding */ Alignment; }
/* harmony export */ });
/* unused harmony export LayoutBackground */
var LinkStyle;
(function(LinkStyle) {
    LinkStyle["Button"] = "Button";
    LinkStyle["HyperLink"] = "HyperLink";
    LinkStyle["MainCta"] = "MainCTA";
})(LinkStyle || (LinkStyle = {}));
var GridDirection;
(function(GridDirection) {
    GridDirection["Row"] = "row";
    GridDirection["RowReverse"] = "row-reverse";
    GridDirection["Column"] = "column";
    GridDirection["ColumnReverse"] = "column-reverse";
})(GridDirection || (GridDirection = {}));
var Alignment;
(function(Alignment) {
    Alignment["Center"] = "Center";
    Alignment["Left"] = "Left";
    Alignment["Right"] = "Right";
})(Alignment || (Alignment = {}));
var LayoutBackground;
(function(LayoutBackground) {
    LayoutBackground["Dark"] = "Dark";
    LayoutBackground["Light"] = "Light";
})(LayoutBackground || (LayoutBackground = {}));


/***/ }),

/***/ 87113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "mo": function() { return /* binding */ ImageContainer; },
  "Zp": function() { return /* binding */ defaultAlt; }
});

// UNUSED EXPORTS: RegisterImgStyle

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./constants/path.ts
var path = __webpack_require__(96703);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/SmallPrintTerms/style.module.scss
var style_module = __webpack_require__(10416);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./components/SmallPrintTerms/index.tsx





var SmallPrintTerms = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (style_module_default()).smallPrint,
        children: [
            "Our",
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                prefetch: false,
                href: path/* PATH.TERMS_AND_CONDITIONS */.m.TERMS_AND_CONDITIONS,
                as: path/* PATH.TERMS_AND_CONDITIONS */.m.TERMS_AND_CONDITIONS,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: (style_module_default()).link,
                    href: path/* PATH.TERMS_AND_CONDITIONS */.m.TERMS_AND_CONDITIONS,
                    children: "Terms of Use"
                })
            }),
            " ",
            "and",
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                prefetch: false,
                href: path/* PATH.PRIVACY_POLICY */.m.PRIVACY_POLICY,
                as: path/* PATH.PRIVACY_POLICY */.m.PRIVACY_POLICY,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: (style_module_default()).link,
                    href: path/* PATH.PRIVACY_POLICY */.m.PRIVACY_POLICY,
                    children: "Privacy Policy"
                })
            })
        ]
    });
};
/* harmony default export */ var components_SmallPrintTerms = (SmallPrintTerms);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(29260);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
;// CONCATENATED MODULE: ./components/Image/img/quote.svg
var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

var SvgQuote = function SvgQuote(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 52,
    height: 46,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M12.79 46c-3.927 0-7.068-1.42-9.424-4.26C1.122 38.789 0 34.984 0 30.327c0-6.36 1.683-12.096 5.049-17.207C8.526 7.894 13.799 3.52 20.867 0l1.851 2.726c-3.365 2.044-6.45 4.94-9.255 8.689-2.693 3.634-4.039 7.326-4.039 11.074 0 1.022.28 1.874.841 2.555.561.568 1.403.852 2.525.852 2.804 0 5.16 1.023 7.068 3.067 2.019 1.93 3.029 4.316 3.029 7.155 0 2.84-1.01 5.225-3.03 7.156C17.95 45.091 15.595 46 12.79 46Zm29.113 0c-3.927 0-7.068-1.42-9.424-4.26-2.244-2.952-3.366-6.757-3.366-11.414 0-6.36 1.683-12.096 5.049-17.207C37.64 7.894 42.912 3.52 49.98 0l1.85 2.726c-3.365 2.044-6.45 4.94-9.255 8.689-2.693 3.634-4.039 7.326-4.039 11.074 0 1.022.28 1.874.842 2.555.56.568 1.402.852 2.524.852 2.805 0 5.16 1.023 7.068 3.067C50.99 30.893 52 33.279 52 36.118c0 2.84-1.01 5.225-3.03 7.156C47.065 45.091 44.709 46 41.904 46Z",
    fill: "#C0E8FF"
  })));
};
/* harmony default export */ var quote = (SvgQuote);
// EXTERNAL MODULE: ./components/Image/style.module.scss
var Image_style_module = __webpack_require__(20027);
var Image_style_module_default = /*#__PURE__*/__webpack_require__.n(Image_style_module);
;// CONCATENATED MODULE: ./components/Image/index.tsx
/* eslint-disable react/jsx-boolean-value */ 







var defaultAlt = "Medrecruit Image";
var convertToArray = function(item) {
    return Array.isArray(item) ? item : [
        item
    ];
};
var RegisterImgStyle;
(function(RegisterImgStyle) {
    RegisterImgStyle["Img"] = "img";
    RegisterImgStyle["OverlayImage"] = "overlayImage";
})(RegisterImgStyle || (RegisterImgStyle = {}));
var ImageContainer = function(param) {
    var img = param.img, imgStyle = param.imgStyle, imgAlt = param.imgAlt, overlayCenteredText = param.overlayCenteredText, overlayTextInBox = param.overlayTextInBox, width = param.width, height = param.height, whiteBackground = param.whiteBackground;
    var text = overlayCenteredText || overlayTextInBox;
    var textStyle = overlayCenteredText ? (Image_style_module_default()).centeredText : (Image_style_module_default()).overlayCenteredTextInBox;
    var termsStyle = overlayTextInBox ? (Image_style_module_default()).greyText : overlayCenteredText ? (Image_style_module_default()).hidden : (Image_style_module_default()).whiteText;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Image_style_module_default()).imgContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()(imgStyle === RegisterImgStyle.OverlayImage ? (Image_style_module_default()).overlayImage : (Image_style_module_default()).img),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    priority: true,
                    width: width,
                    height: height,
                    src: img,
                    alt: imgAlt || defaultAlt,
                    title: imgAlt || defaultAlt
                })
            }),
            text && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((Image_style_module_default()).textContainer, textStyle, whiteBackground && (Image_style_module_default()).whiteBackground),
                children: [
                    overlayTextInBox && /*#__PURE__*/ (0,jsx_runtime.jsx)(quote, {}),
                    convertToArray(text).map(function(text, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: overlayCenteredText ? "h4" : index === 0 ? "subtitle1" : "caption",
                            display: "block",
                            component: "p",
                            children: text
                        }, "".concat(text, "-").concat(index));
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((Image_style_module_default()).finePrint, termsStyle, whiteBackground && (Image_style_module_default()).paleBlueText),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SmallPrintTerms, {})
            })
        ]
    });
};


/***/ }),

/***/ 88460:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"childrenContainer":"style_childrenContainer__d3pAq"};

/***/ }),

/***/ 95815:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"itemContent":"style_itemContent__Bp6T7","itemContainer":"style_itemContainer__9JZLG","img":"style_img__TA2nF","heading":"style_heading__nBXBM","Three_Column":"style_Three_Column__y9uaU","imgWrapper":"style_imgWrapper__Kbt4a","Two_Column":"style_Two_Column__9pw15","One_Column":"style_One_Column__VJZJ_","title":"style_title__69v9t","Full_Width":"style_Full_Width__zfhdb","blurb":"style_blurb__QwJbd","linkText":"style_linkText__jys6U","imageSlider":"style_imageSlider__KUKOj","notImageSlider":"style_notImageSlider__nAb2t"};

/***/ }),

/***/ 14801:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"content":"ImageTextCover_content__U6omP","title":"ImageTextCover_title__PraLg","blurb":"ImageTextCover_blurb__2_XvG","lightBackground":"ImageTextCover_lightBackground__v__2y","img":"ImageTextCover_img__KBFh3","leftImage":"ImageTextCover_leftImage___H6JC","imageContainer":"ImageTextCover_imageContainer__Ty96z","imageWrapper":"ImageTextCover_imageWrapper___S3EK"};

/***/ }),

/***/ 99263:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__Rcefn","hyperLink":"style_hyperLink__g4rtX","Center":"style_Center__DL8Bq","Left":"style_Left__zB0JX","Right":"style_Right__AjXfw","button":"style_button__gvJJG","MainCTA":"style_MainCTA__91BON","linkText":"style_linkText__cHMTR"};

/***/ }),

/***/ 57231:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"markdown":"style_markdown__ACijO"};

/***/ }),

/***/ 91066:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imageAndLinkTitle":"style_imageAndLinkTitle____viQ","videoPlayer":"style_videoPlayer__ZQkbF"};

/***/ }),

/***/ 88415:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"containerMarginL":"style_containerMarginL__Xin_m","containerMarginM":"style_containerMarginM__gcEkK","containerMarginS":"style_containerMarginS__uOEYv","containerPaddingS":"style_containerPaddingS__F37JV","markdownContent":"style_markdownContent__x1pNa"};

/***/ }),

/***/ 20027:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imgContainer":"style_imgContainer__okrSE","img":"style_img__XGlaq","overlayImage":"style_overlayImage__JBqLw","textContainer":"style_textContainer__Amkh2","centeredText":"style_centeredText__2FA7k","overlayCenteredTextInBox":"style_overlayCenteredTextInBox__Fudym","finePrint":"style_finePrint__Jzs6x","whiteText":"style_whiteText__k32cQ","greyText":"style_greyText__NEUAp","hidden":"style_hidden__EqpuW","centeredImg":"style_centeredImg__t2PIR","droplets":"style_droplets__Y3htk","whiteBackground":"style_whiteBackground__ByG1F","paleBlueText":"style_paleBlueText__yr_OJ"};

/***/ }),

/***/ 10416:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"smallPrint":"style_smallPrint__n1vZC"};

/***/ })

}]);